/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useContext, useState } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
    Column,
    Container,
    Divider,
    ErrorBoundary,
    Header,
    // Heading,
    Row,
    Spacer,
    UserContext
} from 'school-space-client/components';
import { updateCustomer } from 'school-space-client/api';

import WelcomeTermsConditions from 'dashboard/screens/WelcomeTermsConditions';
import WelcomeDetailsInfo from 'dashboard/screens/WelcomeDetailsInfo';
import WelcomeDetailsAddress from 'dashboard/screens/WelcomeDetailsAddress';
import HowDidYouHearAboutUsTypeForm from 'dashboard/screens/HowDidYouHearAboutUsTypeForm';

import withNotifications from 'shared/context/notification/withNotifications';

const css = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
    },
    contentWrapper: {
        flexGrow: '1'
    },
    button: theme => ({
        maxWidth: theme.layout.baseline * 16
    }),
    header: {
        textAlign: 'center'
    }
};
const customerStruct = {
    created_at: null,
    discount: 0,
    firstName: null,
    lastName: null,
    organisation: null,
    phone: null,
    email: null,
    termsAgreed: false,
    address: {
        addressLine1: null,
        addressLine2: null,
        townCity: null,
        postCode: null,
        country: null
    }
};
const verificationsSteps = ['details', 'address', 'howdidyouhear', 'termsandcondition'];
const Welcome = ({ history, context: { showNotification } }) => {
    const [verifications, setVerifications] = useState(verificationsSteps[0]);
    const [loading, setLoading] = useState(false);

    const user = useContext(UserContext);
    if (user.address === null) {
        user.address = customerStruct.address;
    }
    const [customer, setCustomer] = useState(user);
    if (user.termsAgreed) {
        return <Redirect to="/" />;
    }
    const updateCustomerData = async () => {
        setLoading(true);
        try {
            const payload = {
                joined: customer.joined,
                discount: customer.discount,
                firstName: customer.firstName,
                lastName: customer.lastName,
                organisation: customer.organisation,
                phone: customer.phone,
                email: customer.email,
                termsAgreed: true,
                address: {
                    addressLine1: customer.address.addressLine1,
                    addressLine2: customer.address.addressLine2,
                    townCity: customer.address.townCity,
                    postCode: customer.address.postCode,
                    country: customer.address.country
                },
                onBoarding: false,
                customerType: customer.customerType
            };

            user.setTermsAgreed(true);
            await updateCustomer(user.id, { ...payload });
            setLoading(false);
            return history.push('/');
        } catch (error) {
            if (error.name === 'ApiValidationError') {
                const checkCustomerDetailsValidations = (error.data || []).filter(
                    item =>
                        item.field === 'firstName' ||
                        item.field === 'lastName' ||
                        item.field === 'organisation' ||
                        item.field === 'phone'
                );
                if (checkCustomerDetailsValidations.length > 0) {
                    setVerifications(verificationsSteps['0']);
                }

                const checkCustomerAddressValidations = (error.data || []).filter(
                    item => item.field === 'address'
                );
                if (checkCustomerAddressValidations.length > 0) {
                    setVerifications(verificationsSteps['1']);
                }

                const checkTNCValidations = (error.data || []).filter(
                    item => item.field === 'termsAgreed'
                );
                if (checkTNCValidations.length > 0) {
                    setVerifications(verificationsSteps['2']);
                }
            }
            setLoading(false);
            return showNotification('Error updating customer. ⛔️', error);
        }
    };

    return (
        <div css={css.wrapper}>
            <Header isMinimal />
            <Divider />
            <Container styles={css.contentWrapper}>
                <Spacer height={4} />
                <Row verticalAlign="flex-start">
                    <Column styles={css.content} s={[6]} m={[8, 2, 2]} l={[6, 3, 3]}>
                        <ErrorBoundary>
                            {verifications === verificationsSteps[0] && (
                                <WelcomeDetailsInfo
                                    onChangeStep={step => setVerifications(step)}
                                    customer={customer}
                                    setCustomer={setCustomer}
                                    verificationsSteps={verificationsSteps}
                                    loading={loading}
                                />
                            )}
                            {verifications === verificationsSteps[1] && (
                                <WelcomeDetailsAddress
                                    onChangeStep={step => setVerifications(step)}
                                    customer={customer}
                                    setCustomer={setCustomer}
                                    verificationsSteps={verificationsSteps}
                                    loading={loading}
                                />
                            )}
                            {verifications === verificationsSteps[2] && (
                                <HowDidYouHearAboutUsTypeForm
                                    onChangeStep={step => setVerifications(step)}
                                    verificationsSteps={verificationsSteps}
                                />
                            )}
                            {verifications === verificationsSteps[3] && (
                                <WelcomeTermsConditions
                                    onChangeStep={step => {
                                        setVerifications(step);
                                        updateCustomerData();
                                    }}
                                    customer={customer}
                                    setCustomer={setCustomer}
                                    verificationsSteps={verificationsSteps}
                                    loading={loading}
                                />
                            )}
                        </ErrorBoundary>
                    </Column>
                </Row>
            </Container>
            <Spacer height={3} />
        </div>
    );
};

Welcome.propTypes = {
    history: ReactRouterPropTypes.history.isRequired,
    context: PropTypes.objectOf(PropTypes.any).isRequired
};

export default withNotifications(Welcome);
